import { render, staticRenderFns } from "./BillingSideInfo.vue?vue&type=template&id=6936c748"
import script from "./BillingSideInfo.vue?vue&type=script&lang=js"
export * from "./BillingSideInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports